import { LOGIN, LOGOUT } from './actions_types'
import { SET_AUTH, RESET_AUTH, CLEAR_SESSION } from './mutations_types'
import { api } from '../plugins/axios_settings'
import _localStorage from '@/plugins/local_storage'
// import cookie from 'vue-cookie'

const state = {
  isAuthenticated: false,
  showLoader: false,
  authToken: '',
  userDetails: {},
  isLoggedIn: false
}

const getters = {
  getuserDetails (state) {
    return state.userDetails
  },
  isAuthenticated (state) {
    return state.isAuthenticated
  }
}

const actions = {
  [LOGIN] (context, model) {
    return new Promise((resolve, reject) => {
      var date = new Date()
      date.setDate(date.getDate() + 4)
      // eslint-disable-next-line camelcase
      let { id, name, token, so_user_id, isadmin } = model
      let user = JSON.stringify({ id, name, so_user_id, isadmin })
      _localStorage.setWithExpiry(process.env.VUE_APP_TOKEN, token, 7)
      _localStorage.setWithExpiry(process.env.VUE_APP_USER, user, 7)
      /* cookie.set(process.env.VUE_APP_TOKEN, token) // , { expires: date, secure: true, sameSite: 'None' }
      cookie.set(process.env.VUE_APP_USER, user) // , { expires: date, secure: true, sameSite: 'None' } */
      context.commit(SET_AUTH, { authToken: token, user: JSON.parse(user) })
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`
      resolve()
    })
  },
  [LOGOUT] ({ commit }) {
    _localStorage.remove(process.env.VUE_APP_TOKEN)
    _localStorage.remove(process.env.VUE_APP_USER)
    /* cookie.delete(process.env.VUE_APP_TOKEN)
    cookie.delete(process.env.VUE_APP_USER) */
    window.localStorage.removeItem('FilterByColumns')
    commit(RESET_AUTH)
  }
}

const mutations = {
  [SET_AUTH] (state, data) {
    state.userDetails = data.user
    state.authToken = data.authToken
    state.isAuthenticated = true
  },
  [RESET_AUTH] (state) {
    state.isAuthenticated = false
    state.authToken = null
    state.userDetails = {}
  },
  [CLEAR_SESSION] (state) {
    state.isAuthenticated = false
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}
